import classNames from 'classnames';

import styles from './Base.module.scss';
import { BaseProps } from './Base.types';

export const Base = ({ icon, children, className }: BaseProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
